/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  FAQ DATA
  ============================================================

  Demon UKK-sisältö.

  Varsinaisessa asiakastoteutuksessa:
  - kysymyksiä voidaan lisätä
  - kysymyksiä voidaan poistaa
  - järjestystä voidaan vaihtaa
  - FI / EN voidaan muokata
  - osio voidaan piilottaa

  Rakenne soveltuu myöhemmin WordPress REST API -dataan.
*/

const faqData = {
  sessions: {
    enabled: true,

    eyebrow: {
      fi: "Usein kysyttyä",
      en: "Frequently asked",
    },

    title: {
      fi:
        "Mitä ennen kuvausta yleensä mietitään.",

      en:
        "What people usually wonder before a session.",
    },

    description: {
      fi:
        "Kaikkea ei tarvitse tietää valmiiksi. Tässä vastauksia yleisimpiin kysymyksiin ennen kuvausta.",

      en:
        "You do not need to have everything figured out beforehand. Here are answers to some of the most common questions before a session.",
    },

    items: [
      {
        id: "booking",

        question: {
          fi:
            "Kuinka aikaisin kuvaus kannattaa varata?",

          en:
            "How far in advance should I book?",
        },

        answer: {
          fi:
            "Mitä tärkeämpi tietty päivämäärä on, sitä aikaisemmin kannattaa olla yhteydessä. Häät ja muut tapahtumat varataan usein hyvissä ajoin, mutta henkilö-, pari- ja yrityskuvauksiin voi löytyä vapaita aikoja myös lähempänä ajankohtaa.",

          en:
            "The more important a specific date is, the earlier it is worth getting in touch. Weddings and events are often booked well in advance, while portrait, couple and business sessions may also be available on shorter notice.",
        },
      },

      {
        id: "posing",

        question: {
          fi:
            "Entä jos en osaa olla kameran edessä?",

          en:
            "What if I am not comfortable in front of a camera?",
        },

        answer: {
          fi:
            "Sinun ei tarvitse osata poseerata. Kuvauksen aikana saat tarvittaessa selkeää ja rauhallista ohjausta, mutta tavoitteena on pitää tilanne luonnollisena ja antaa myös aidoille hetkille tilaa.",

          en:
            "You do not need to know how to pose. You will receive calm and clear guidance whenever needed, while leaving enough space for the session to feel natural and genuine.",
        },
      },

      {
        id: "location",

        question: {
          fi:
            "Missä kuvaus voidaan järjestää?",

          en:
            "Where can the session take place?",
        },

        answer: {
          fi:
            "Kuvaus voidaan toteuttaa studiossa, ulkona, asiakkaan omassa ympäristössä tai muussa yhdessä valitussa miljöössä. Paikka valitaan sen mukaan, millaista tunnelmaa ja käyttötarkoitusta kuville haetaan.",

          en:
            "The session can take place in a studio, outdoors, in your own environment or at another selected location. The setting is chosen according to the desired atmosphere and purpose of the photographs.",
        },
      },

      {
        id: "weather",

        question: {
          fi:
            "Mitä jos sää on huono?",

          en:
            "What happens if the weather is bad?",
        },

        answer: {
          fi:
            "Sään vaikutus arvioidaan aina kuvauskohtaisesti. Kevyt sade tai pilvinen sää voi toimia kuvissa hienosti, mutta tarvittaessa voidaan vaihtaa paikkaa, muuttaa suunnitelmaa tai sopia uusi aika.",

          en:
            "Weather is considered individually for each session. Light rain or cloudy conditions can work beautifully, but the location, plan or session time can be changed when necessary.",
        },
      },

      {
        id: "delivery",

        question: {
          fi:
            "Milloin valmiit kuvat toimitetaan?",

          en:
            "When will the finished photographs be delivered?",
        },

        answer: {
          fi:
            "Toimitusaika riippuu kuvauksen laajuudesta ja sesongista. Arvio toimitusajasta sovitaan aina ennen kuvausta, ja valmiit kuvat toimitetaan yleensä yksityisen verkkogallerian kautta.",

          en:
            "Delivery time depends on the scope of the session and the season. An estimated delivery schedule is always agreed beforehand, and finished photographs are typically delivered through a private online gallery.",
        },
      },

      {
        id: "selection",

        question: {
          fi:
            "Saanko itse valita toimitettavat kuvat?",

          en:
            "Do I choose the photographs myself?",
        },

        answer: {
          fi:
            "Kuvien valintatapa riippuu valitusta kuvauskokonaisuudesta. Kuvaaja tekee aina teknisen ja taiteellisen esikarsinnan, jotta galleriaan päätyy onnistunut ja yhtenäinen kokonaisuus.",

          en:
            "The selection process depends on the chosen session package. The photographer always makes the initial technical and artistic selection so that the final gallery forms a strong and coherent collection.",
        },
      },
    ],
  },

  pricing: {
    enabled: true,

    eyebrow: {
      fi: "Hinnastosta",
      en: "About pricing",
    },

    title: {
      fi:
        "Muutama asia ennen päätöstä.",

      en:
        "A few things before you decide.",
    },

    description: {
      fi:
        "Valmiit paketit helpottavat vertailua, mutta kuvaus voidaan rakentaa myös tarpeen mukaan.",

      en:
        "The ready-made collections make comparison easier, but a session can also be tailored around what you need.",
    },

    items: [
      {
        id: "included",

        question: {
          fi:
            "Mitä kuvaushintaan sisältyy?",

          en:
            "What is included in the session price?",
        },

        answer: {
          fi:
            "Pakettien tarkka sisältö näkyy hinnastossa. Kokonaisuuteen kuuluu valitun paketin mukainen kuvausaika, kuvauksen suunnittelu, kuvien valinta ja viimeistely sekä sovittu toimitustapa.",

          en:
            "The exact contents of each collection are listed in the pricing section. The total includes the agreed session time, planning, image selection and editing, and the agreed delivery method.",
        },
      },

      {
        id: "tailored",

        question: {
          fi:
            "Voiko pakettia muokata?",

          en:
            "Can a collection be customised?",
        },

        answer: {
          fi:
            "Kyllä. Hinnaston paketit toimivat lähtökohtina. Jos tarvitset esimerkiksi pidemmän kuvausajan, useamman miljöön tai erilaisen kokonaisuuden, siitä voidaan tehdä oma tarjous.",

          en:
            "Yes. The listed collections are starting points. If you need more time, several locations or a different type of coverage, a tailored quote can be created.",
        },
      },

      {
        id: "travel",

        question: {
          fi:
            "Sisältyvätkö matkakulut hintaan?",

          en:
            "Are travel expenses included?",
        },

        answer: {
          fi:
            "Matkakulujen käytäntö riippuu kuvauspaikasta ja sovitaan tarjouksen yhteydessä. Näin kokonaiskustannus on tiedossa ennen varauksen vahvistamista.",

          en:
            "Travel costs depend on the location and are agreed as part of the quote. This way the total cost is clear before the booking is confirmed.",
        },
      },

      {
        id: "reservation",

        question: {
          fi:
            "Milloin varaus on vahvistettu?",

          en:
            "When is the booking confirmed?",
        },

        answer: {
          fi:
            "Varaus vahvistetaan sovitulla tavalla tarjouksen hyväksymisen ja mahdollisten varausehtojen täyttymisen jälkeen. Tarkat ehdot kerrotaan aina ennen sitovaa varausta.",

          en:
            "The booking is confirmed after the quote has been accepted and any agreed booking conditions have been fulfilled. The exact terms are always provided before a binding reservation.",
        },
      },

      {
        id: "extra",

        question: {
          fi:
            "Voiko kuvaukseen lisätä palveluita myöhemmin?",

          en:
            "Can I add services later?",
        },

        answer: {
          fi:
            "Usein kyllä. Esimerkiksi lisäaikaa, albumin tai muita lisäpalveluita voidaan tilanteesta riippuen lisätä myös varauksen jälkeen. Saatavuus varmistetaan tapauskohtaisesti.",

          en:
            "Often yes. Additional coverage, albums or other services can usually be added after booking, depending on availability and the type of session.",
        },
      },
    ],
  },
};

export default faqData;